import React, { useEffect, useRef, useState } from 'react'
import ChatCustomer from '../components/ChatCustomer'
import RecentSuccessOperation from '../components/RecentSuccessOperation'
import ServiceDisponible from '../components/ServiceDisponible'
import StatisticOfOperations from '../components/StatisticOfOperations'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleLeft, faForward } from '@fortawesome/free-solid-svg-icons'
import BottomNavBar from '../components/BottomNavBar'
import { useHistory } from 'react-router-dom'

export default function ContactScreen(props) {

  const history  = useHistory()

  const STATUS = { STARTED: 'Traitement en cours...', }
  
    const INITIAL_COUNT1 = 300
  
    const [secondsRemaining1,            setSecondsRemaining1 ] = useState(INITIAL_COUNT1)
    const [status1,                      setStatus1           ] = useState(STATUS.STOPPED)

    const LineLink = true

    const [isMenuVisible, setMenuVisibility] = useState(true);
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

    const handleScroll = () => {
        const currentScrollPos = window.pageYOffset;
        const isVisible = prevScrollPos > currentScrollPos;
    
        setMenuVisibility(isVisible);
        setPrevScrollPos(currentScrollPos);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [prevScrollPos]);
  
    useEffect(()=>{
      setStatus1(STATUS.STARTED)
    },[STATUS.STARTED])

  useInterval(
    () => {
    if (secondsRemaining1 > 0) {
        setSecondsRemaining1(secondsRemaining1 - 1)
    } else {
        setStatus1(STATUS.STOPPED)
    }
    },

    status1 === STATUS.STARTED ? 1000 : null,
    // passing null stops the interval
)

function useInterval(callback, delay) {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(() => {
    savedCallback.current = callback
    }, [callback])

// Set up the interval.
useEffect(() => {
  function tick() {
    savedCallback.current()
  }
  if (delay !== null) {
    let id = setInterval(tick, delay)
    return () => clearInterval(id)
  }
}, [delay])
}

var [themeMode, setThemeMode] = useState()

let ThemeMode = localStorage.getItem("ThemeMode")

useEffect(()=>{
  
  if(secondsRemaining1 > 0){
    setThemeMode(ThemeMode)
  }

},[ThemeMode, secondsRemaining1])

  var _ProWallet = localStorage.getItem('_ProWallet')

  if (_ProWallet === 'true') {
    props.history.push('/nkab-pro')
  }
    
  // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.

  function handleLogout(){

    localStorage.clear();

    if(_ProWallet === "true"){
      localStorage.setItem("isRActive",false)
      localStorage.setItem("_ProWallet", true)
      localStorage.setItem("userStatus", "Logout")

      if(LineLink){
        window.location.replace("https://nkab-exchange.net/login");
      } else {
         window.location.replace("http://localhost:3000/login");
      }
    }
    if(_ProWallet === "false"){
      localStorage.setItem("isRActive",false)
      localStorage.setItem("_ProWallet", false)
      localStorage.setItem("userStatus", "Logout")
    }
    
    localStorage.setItem("isRActive",false)

    if(LineLink){
      window.location.replace("https://nkab-exchange.net/login");
    } else {
       window.location.replace("http://localhost:3000/login");
    }
  }


  return (
    <div>
      <div className="container">
        <div className="mt-5">
          <div className="d-flex justify-content-between">
            <div style={{ marginBottom: `${'10px'}` }}>
              <span
                className='goback'
                onClick={() => history.goBack()}
                style={{ color: '#0a146e', cursor: 'pointer' }}
              >
                <FontAwesomeIcon icon={faArrowAltCircleLeft} /> {'Retour'}
              </span>
            </div>
            <div style={{ marginBottom: `${'10px'}` }}>
              <a href="/sell-or-buy-crypto" style={{textDecoration:"none"}}>
                <span
                  type="submit"
                  className='goback'
                  style={{ color: '#0a146e', cursor: 'pointer' }}
                >
                  <FontAwesomeIcon icon={faForward} /> {'Accueil du service'}
                </span>
              </a>
            </div>
          </div>
          <div className="d-flex justify-content-between">
            <div className={`${themeMode === "true" ? "contact-content-elment contact-content-elment-t animate__animated animate__fadeInDown" : "contact-content-elment animate__animated animate__fadeInDown"}`}>
              <h4> <strong style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>Où vous pouvez nous écrire</strong></h4>
              <div className="contact-session-title text-center">
                <p style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>Contactez-nous via des moyens de communication plus rapide et plus aisés.</p>
                <div className='row'>
                  <div className='col-md-3'></div>
                    <div className='col-md-3'>
                      <a href="https://wa.me/message/6HY3WGBCUAH6G1" className="icoFacebook" title="Facebook">
                        <img src="../../images/whatsapp-icon.png" alt="" width="50" height="50" />
                      </a>
                    </div>
                    <div className='col-md-3'>
                      <a href="https://t.me/+SV_lGX2Bl9cxNmFk" className="icoFacebook" title="Facebook">
                        <img src="../../images/telegram-icon.png" alt="" width="50" height="50" />
                      </a>
                    </div>
                  <div className='col-md-3'></div>
                </div>
              </div>
              <div className="text-center">
                <p style={{color:`${themeMode === "true" ? "#90d9ff" : ""}`}}>NKAB EXCHANGE est une plateforme d'échange de crypto-actifs et de transfert d'argent national et international basée en Afrique de l'Ouest développée par NK Group Technology dont Elle est une filiale.</p>
              </div>
              {/* <div className={`${themeMode === "true" ? "head-button-content head-button-content-t" : "head-button-content"}`}>
                <div className="d-flex justify-content-between">
                  <button className="buy-button-head" style={{borderRadius:'50px'}}>
                    <Link to="/sell-or-buy-crypto" style={{ color: `${'#ffffff'}` }} > Acheter des crypto-actifs
                    </Link>
                  </button>
                  <button className="sell-button-head" style={{borderRadius:'50px'}}>
                    <Link to="/sell-or-buy-crypto" style={{ color: `${'#ffffff'}` }} >
                      Vendre mes crypto-actifs
                    </Link>
                  </button>
                </div>
              </div> */}
            </div>
            <div className="about-img-session animate__animated animate__flipInY">
              <img
                className="contact-image"
                src="../images/contact-us.png"
                alt="Logo NKAB Exchange"
              />
            </div>
          </div>
        </div>

        <ServiceDisponible />
        <RecentSuccessOperation />
        <StatisticOfOperations />

        <ChatCustomer />

      </div>
      <BottomNavBar />
    </div>
  )
}
